module.exports = __webpack_public_path__ + "static/media/img1-3.fc0bdfab.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/nutricheck_suelo/NO3/img1-3.png
// module id = 1233
// module chunks = 3